"use strict";
/** 即时编译 JSExpression */
Object.defineProperty(exports, "__esModule", { value: true });
exports.compile = exports.init = void 0;
var events_1 = require("events");
var worker;
var init = function () {
    if (worker)
        return;
    var blob = new Blob(["\n  self.importScripts('https://cdn.calendar.tencent.com/calendar_res/cdn/babel@7.21.2.min.js');\n  self.onmessage = ({ data: { source, id } }) => {\n    const { code } = self.Babel.transform(source, { plugins: [\"proposal-optional-chaining\", \"transform-arrow-functions\", \"transform-spread\", \"proposal-object-rest-spread\"] });\n    self.postMessage({code, id});\n  };\n  "], { type: 'application/javascript' });
    worker = new Worker(URL.createObjectURL(blob));
    worker.onmessage = function (payload) {
        event.emit(payload.data.id, payload.data);
    };
};
exports.init = init;
var getId = (function () {
    var cur = Date.now();
    return function () { return "node_".concat((cur += 1).toString(12)); };
})();
var event = new events_1.EventEmitter();
var compile = function (source) {
    var id = getId();
    if (!worker) {
        init();
    }
    worker.postMessage({ source: source, id: id });
    return new Promise(function (res) {
        event.once(id, function (ret) {
            res(ret.code);
        });
    });
};
exports.compile = compile;
